<template>
  <div
    class="day-detail-item"
    :class="dayDetailClasses"
    :style="taskStyle"
  >
    <slot></slot>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'

export default {
  name: 'DayDetailItem',
  props: {
    index: {
      type: Number,
      default: 0
    },
    last: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitScrollUp (index, delay) {
      setTimeout(() => {
        if (index > 3) {
          const newIndex = index - 3
          EventBus.$emit('scrollUp', (newIndex * 63))
        }
      }, delay)
    }
  },
  computed: {
    taskStyle () {
      const index = this.index
      let delay = 500
      for (let i = 1; i <= index; i++) {
        delay += 1000 / (i / 2)
      }
      delay = Math.ceil(delay)
      this.emitScrollUp(index, delay)
      return {
        'animation-delay': delay + 'ms'
      }
    },
    dayDetailClasses () {
      return {
        'is-last': this.last,
        'is-not-last': !this.last
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes panelFade {
  from {
    opacity: 0;
    transform: translateY(15px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translate(0px) scale(1);
  }
}
.day-detail-item {
  font-size: 20px;
  color: #313345;
  background-color: white;
  border-radius: 5px;
  margin-top: 7px;
  padding: 18px 25px;
  opacity: 0;
  transform: translateY(25px) scale(0.9);
  animation: panelFade 200ms linear forwards;
}
.is-last {
  animation-duration: 800ms;
  background-color: #313345;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/alarm/DayDetailItem.vue